export const IconMenu = () => {
  return (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='50' height='50' rx='8' fill='#278CEA'/>
      <line x1='12.5' y1='16.5' x2='38.5' y2='16.5' stroke='white' strokeWidth='3' strokeLinecap='round'/>
      <line x1='12.5' y1='25.5' x2='38.5' y2='25.5' stroke='white' strokeWidth='3' strokeLinecap='round'/>
      <line x1='12.5' y1='34.5' x2='38.5' y2='34.5' stroke='white' strokeWidth='3' strokeLinecap='round'/>
    </svg>
  )
}
